module.exports = __webpack_public_path__ + "img/instagram-story.b581100e.png";